module.exports = __webpack_public_path__ + "static/media/bangkokmidtown.3aecf2f8.png";